var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7499 18.0368V11.6275C17.7499 8.47752 17.0717 6.07129 13.3968 6.07129C11.6249 6.07129 10.4437 7.03378 9.9624 7.95253H9.91865V6.35566H6.44055V18.0368H10.0718V12.24C10.0718 10.7088 10.3562 9.24314 12.2374 9.24314C14.0968 9.24314 14.1186 10.9713 14.1186 12.3275V18.015H17.7499V18.0368Z",
    fill: "#1D191F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.534424 6.35645H4.16565V18.0376H0.534424V6.35645Z",
    fill: "#1D191F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34999 0.537109C1.19062 0.537109 0.25 1.47773 0.25 2.6371C0.25 3.79646 1.19062 4.75896 2.34999 4.75896C3.50935 4.75896 4.44997 3.79646 4.44997 2.6371C4.44997 1.47773 3.50935 0.537109 2.34999 0.537109Z",
    fill: "#1D191F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.a4fbebbe4f74f23bf2f8d7438adc0e2e.svg";
export { ForwardRef as ReactComponent };